import * as THREE from 'three'
import { ProtoBase, easeOutCubic } from '../ProtoBase'

/** ① 雲海ジオラマ — 雲海を突き破って「白木の日本列島」が浮上する */
export class Proto1 extends ProtoBase {
  readonly title = '1. 雲海ジオラマ'
  readonly desc = '眼下の雲海を突き破り、木でできた日本列島が浮かび上がる'

  protected start(): void {
    this.ctx.setWorld('map')
    this.ctx.markers.setLabelsVisible(false)
    this.ctx.terrain.setCloudsVisible(true)
    this.ctx.terrain.setLandY(-14)
    this.ctx.terrain.setLineOpacity(0)
    this.ctx.markers.root.visible = false
    this.ctx.setCaption('雲の下に——')
  }

  update(dt: number): void {
    this.elapsed += dt
    const t = this.elapsed % 20 // 20秒ループ

    if (t < 2) {
      this.ctx.terrain.setLandY(-14)
      this.ctx.terrain.setLineOpacity(0)
      this.ctx.markers.root.visible = false
    } else if (t < 9) {
      const u = easeOutCubic((t - 2) / 7)
      this.ctx.terrain.setLandY(-14 + u * 14.3)
      if (t > 4.4 && t < 4.6) this.ctx.sfx.play('drum')
      if (t > 4.5) this.ctx.setCaption('木でできた日本が、浮かび上がる')
    } else if (t < 12) {
      const u = (t - 9) / 3
      this.ctx.terrain.setLineOpacity(u * 0.55)
      if (!this.ctx.markers.root.visible && u > 0.5) {
        this.ctx.markers.root.visible = true
        this.ctx.markers.setLabelsVisible(false)
        this.ctx.sfx.play('bell')
        this.ctx.setCaption('六十六の寄進地が、目を覚ます')
      }
    } else if (t > 17) {
      // 沈んでループ
      const u = (t - 17) / 3
      this.ctx.terrain.setLandY(0.3 - u * 14.3)
      this.ctx.terrain.setLineOpacity(0.55 * (1 - u))
      this.ctx.markers.root.visible = false
      if (t > 19.5) this.ctx.setCaption('雲の下に——')
    }
  }

  protected onDispose(): void {
    this.ctx.terrain.resetTransforms()
    this.ctx.markers.root.visible = true
    this.ctx.markers.setLabelsVisible(true)
  }
}
